/***
 * Typescript note for devs:
 * As a feature, Typescript allows for namespaces and enums to share the same name in a given scope.
 * This means that a namespace can have an enum value. For example here the name
 * `SystemOfMeasure` can reference either the enum value of a SystemOfMeasure (standard:3098 or metric:3099), or it
 * can be referencing the namespace `SystemOfMeasure`.
 */

export class Measurements {
  static readonly WeightUnit = {
    lbs: 1283,
    kg: 1284,
  };

  static getWeightUnitLabel = (rdn?: number): string => {
    if (!rdn) {
      return '';
    }
    return rdn == Measurements.WeightUnit.lbs ? 'lbs' : 'kg';
  };
}